import React from 'react';
import PropTypes from 'prop-types';
import immutableProps from 'react-immutable-proptypes';

import {
  Header,
  Image,
  Dimmer,
  Loader,
} from 'semantic-ui-react';
import _ from 'lodash';

import {productFormation} from '../../organisms/MainShop/constants';
import getMessage from '../../global/getMessage';

import Payment from './Payment';
import ProductController from './ProductController';

const propTypes = {
  emailOrder     : immutableProps.map.isRequired,
  id             : PropTypes.number.isRequired,
  isUSD          : PropTypes.bool,
  paypalSDKReady : PropTypes.bool.isRequired,
  setPaypalReady : PropTypes.func.isRequired,
  lang           : PropTypes.shape({menu: PropTypes.object}).isRequired,
};

const defaultProps = {isUSD: null};

class Product extends React.PureComponent {

  constructor() {
    super();
    this.state = {
      errorPayment         : null,
      transactionInProcess : false,
    };
    this.onToggleLoader = this.onToggleLoader.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {emailOrder} = nextProps;
    const {emailOrder: prevEmailOrder} = this.props;
    const {transactionInProcess} = this.state;

    if (!emailOrder.equals(prevEmailOrder)) {
      emailOrder.forEach((order) => {
        if (order.get('isLoading') && !transactionInProcess) {
          this.setState({transactionInProcess: true});
        }
        if (!order.get('isLoading') && order.get('isSent') && transactionInProcess) {
          this.setState({transactionInProcess: false});
        }
        if (!order.get('isLoading') && !order.get('isSent')) {
          this.setState({
            errorPayment         : 'Error payment - please retry',
            transactionInProcess : false,
          });
        }
      });
    }
  }

  onToggleLoader(val) {
    if (val) {
      this.setState({errorPayment: null});
    }
    this.setState({transactionInProcess: val});
  }

  render() {
    const {
      id,
      isUSD,
      lang,
      paypalSDKReady,
      setPaypalReady,
    } = this.props;

    const {
      title,
      description,
      img,
      price,
      priceEuro,
    } = productFormation(lang)[id];

    if (typeof isUSD !== 'boolean') {
      return null;
    }

    const content = [];

    _.forOwn(description, (value, key) => {
      content.push(
        <p key={key}>
          {value}
        </p>
      );
    });

    return (
      <div className='MainShop_product'>
        {
          this.state.transactionInProcess && (
            <Dimmer
              active
              inverted
            >
              <Loader
                content={getMessage('section.shop.order.loadingclose', lang)}
                inverted
              />
            </Dimmer>
          )
        }
        <div className='MainShop_product_desc'>
          {
            img !== null && (
              <Image
                avatar
                className='image-product'
                size='small'
                src={img}
              />
            )
          }
          <div className='MainShop_product_desc_detail'>
            <Header as='h2'>{title}</Header>
            {content}
          </div>
        </div>
        <Payment
          currency={isUSD ? '$' : '€'}
          id={id}
          lang={lang}
          onButtonReady={id > 0 && paypalSDKReady ? undefined : setPaypalReady}
          price={isUSD ? price : priceEuro}
          toggleLoader={this.onToggleLoader}
        />
      </div>
    );
  }

}

Product.propTypes = propTypes;

Product.defaultProps = defaultProps;

export default ProductController(Product);



// WEBPACK FOOTER //
// ./src/molecules/Product/Product.js